<template>
    <section>
      <Feature :title="$t('SUPERVISOR_HIPH_PRICE_MAINTAIN')" :iconClass="'fa-handshake-o'">
        <FormRowTwo :fieldNameArr="[$t('STATUS') + ': ', $t('DELTA_PN') + ': ', $t('VENDOR_CODE') + ': ', $t('PLANT') + ': ', $t('FORM_NO') + ': ']"
          :fieldWidthArr="[362, 362, 372, 362, 362]" :fieldSpanWidthArr="[100, 100, 105, 100, 100]">
          <Select class="Select" v-model="status" slot="a">
          <Option v-for="(item, index) in statusList" :value="item.description" :key="index">{{ item.description }}
          </Option>
          </Select>
          <Input class="Input" v-model="deltaPn" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="b" />
          <Input class="Input" v-model="vnCode" search :enter-button="$t('MORE')" @on-search="moreVnCode" slot="c" />
          <Input class="Input" v-model="plant" search :enter-button="$t('MORE')" @on-search="morePlant" slot="d" />
          <Input class="Input" v-model="formNo" search :enter-button="$t('MORE')" @on-search="moreFormNo" slot="e" />
        </FormRowTwo>
        <FormRowTwo :fieldNameArr="[$t('APPLY_DATE')  + ': ', '~']"
          :fieldWidthArr="[362, 282, 412]" :fieldSpanWidthArr="[100, 20, 150]">
          <DatePicker class="Input" v-model="fromRfqDate" type="date" format="yyyy-MM-dd" slot="a">
          </DatePicker>
          <DatePicker class="Input" v-model="toRfqDate" type="date" format="yyyy-MM-dd" slot="b">
          </DatePicker>
        </FormRowTwo>
        <ButtonRow>
          <Button type="success" @click="search($event, true)" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
          <Button type="info" @click="clear" slot="1">{{ $t('CLEAR') }}</Button>
        </ButtonRow>
        <Collapse :accordion="true" v-model="batchCollapse">
          <Panel name="1">
            {{ $t("LABEL_TEXT_BATCH_EDIT") }}
            <Form label-position="right" :label-width="120" :inline="true" slot="content">
              <FormItem :label="$t('COMMENTS')">
                <Icon type="ios-create" size="28" class="text-delta-blue" @click="showBatchCommentsModal" />
              </FormItem>
              <FormItem :label-width="120">
                <Button type="success" @click="handleBatchSubmit('APPROVE')">{{ $t('APPROVE') }}</Button>
              </FormItem>
              <FormItem :label-width="8">
                <Button type="error" @click="handleBatchSubmit('REJECT')">{{ $t('REJECT') }}</Button>
              </FormItem>
            </Form>
          </Panel>
        </Collapse>

        <FormRowTwo :fieldNameArr="[$t('SELECT_ALL') + ': ', '']" :fieldWidthArr="[320]" :fieldSpanWidthArr="[100]">
          <RadioGroup v-model="selectAllType" size="large" slot="a">
            <Radio label="APPROVE">{{ $t('APPROVE') }}</Radio>
            <Radio label="REJECT">{{ $t('REJECT') }}</Radio>
          </RadioGroup>
          <Button type="info" @click="cleanSelectAllType" slot="b">{{ $t('CLEAR_SELECT') }}</Button>
        </FormRowTwo>
  
        <div style="margin: 15px;">
          <Table :columns="quotationColumnList" :data="quotationList" row-key="key" max-height="750">
            <template slot-scope="{ row, index }" slot="action">
              <div v-if="status !== 'Close'">
                <RadioGroup v-model="quotationList[index].action">
                  <Radio style="display: inline-block; font-size: 14px" label="APPROVE">{{ $t("APPROVE") }}</Radio>
                  <Radio style="display: inline-block; font-size: 14px" label="REJECT">{{ $t("REJECT") }}</Radio>
                </RadioGroup>
                <Button shape="circle" size="small" style="width: 80%" @click="clearAction(index)">{{ $t("CLEAR") }}</Button>
              </div>
            </template>
            <template slot-scope="{ row, index }" slot="comments">
              <Icon type="ios-create" size="28" class="text-delta-blue" @click="showCommentsModal(index, row.uuid)" />
            </template>
            <template slot-scope="{ row, index }" slot="historyComments">
              <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showHistoryCommentsModal(index, row.uuid)" />
            </template>
            <template slot-scope="{ row, index }" slot="infoRecord">
              <div v-if="row.infoRecordFlag">
                <span>YES</span>
                <Icon type="ios-create" size="28" class="text-delta-blue" @click="showInfoRecordMaintainModal(index, row.uuid)" />
              </div>
              <div v-else>
                <span>NO</span>
              </div>
            </template>
            <template slot-scope="{ row, index }" slot="singleOrCross">
              <div v-if="quotationList[index].quotationHighPrice && quotationList[index].quotationHighPrice.orgCheck">
                <span v-text="quotationList[index].quotationHighPrice.orgCheck === 'C' ? 'Cross' : 'Single'"></span>
              </div>
            </template>
            <template slot-scope="{ row, index }" slot="priceDifference">
              <div v-if="quotationList[index].quotationHighPrice && quotationList[index].quotationHighPrice.priceDifference">
                <span v-text="quotationList[index].quotationHighPrice.priceDifference + '%'"></span>
              </div>
            </template>
            <template slot-scope="{ row, index }" slot="log">
              <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showLogModal(index, row.uuid)" />
            </template>
            <template slot-scope="{ row, index }" slot="quotationFiles">
              <Icon v-if="quotationList[index].supplierQuotationFiles && quotationList[index].supplierQuotationFiles.filter(attachement => !attachement.deleted).length > 0" type="ios-cloud-download" size="28" class="text-delta-blue" @click="showQuotationFilesModal(index)" />
            </template>
            <template slot-scope="{ row, index }" slot="referenceFile">
              <Icon v-if="quotationList[index].cpcToSupervisorAttachments && quotationList[index].cpcToSupervisorAttachments.filter(attachement => !attachement.deleted).length > 0" type="ios-cloud-download" size="28" class="text-delta-blue" @click="showReferenceFileModal(index)" />
            </template>
          </Table>
          <Row type="flex" justify="space-between">
            <Col type="flex" justify="start">
              {{ $t("COMMON_TEXT_FROM") }} {{ pageObj.page * pageObj.pageSize - (pageObj.pageSize - 1) }} {{ $t("COMMON_TEXT_TO") }}
              <span v-if="pageObj.totalCount < pageObj.page * pageObj.pageSize">{{ pageObj.totalCount }}</span>
              <span v-else> {{ pageObj.page * pageObj.pageSize }}</span>
              {{ $t("COMMON_TEXT_OF") }} {{ pageObj.totalCount }} {{ $t("COMMON_TEXT_ENTRIES") }}
            </Col>
            <Col type="flex" justify="end">
              <Page :total="pageObj.totalCount" :page-size="pageObj.pageSize" :prev-text="$t('COMMON_TEXT_PREV')" :next-text="$t('COMMON_TEXT_NEXT')" @on-change="changePage" @on-prev="changePage(pageObj.page - 1)" @on-next="changePage(pageObj.page + 1)">
              </Page>
            </Col>
          </Row>
        </div>
        <ButtonRow v-if="getSupervisorHighPriceStatus() !== 'Close'">
          <Button type="primary" @click="handleSubmit" slot="1">{{ $t('SUBMIT') }}</Button>
        </ButtonRow>
      </Feature>
      <!-- Delta PN Modal -->
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnModel"
        :title="$t('DELTA_PN_MORE')" @on-ok="confirmDeltaPnValue">
        <Input v-model="deltaPnValue" type="textarea" :rows="10" />
      </Modal>
      <!-- Vendor Code Modal -->
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vnCodeModel"
        :title="$t('VENDOR_CODE_MORE')" @on-ok="confirmVnCodeValue">
        <Input v-model="vnCodeValue" type="textarea" :rows="10" />
      </Modal>
      <!-- Plant Code Modal -->
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="plantModel"
        :title="$t('PLANT_MORE')" @on-ok="confirmPlantValue">
        <Input v-model="plantValue" type="textarea" :rows="10" />
      </Modal>
      <Modal
        v-model="formNoModal"
        :title="$t('FORM_NO_MORE')"
        :draggable="true"
        :sticky="true"
        :reset-drag-position="true"
        :z-index="modalSize"
        @on-ok="confirmFormNoValue"
      >
        <Input
          v-model="formNoValue"
          type="textarea"
          :rows="10"
        />
      </Modal>
      <!-- Batch Comments Modal -->
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
        v-model="batchCommentsModal" :title="$t('COMMENTS')">
        <froala :config="FloraEditorConfig" v-model="batchComments"></froala>
      </Modal>
  
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" 
        v-model="commentsModal" :title="$t('COMMENTS')" @on-ok="confirmComments">
        <froala :config="FloraEditorConfig" v-model="comments"></froala>
      </Modal>
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
        v-model="historyCommentsModal" :title="$t('HISTORY_COMMENTS')">
        <froala :config="FloraEditorConfig" v-model="historyComments"></froala>
      </Modal>
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
        v-model="infoRecordMaintainModal" :title="$t('INFO_RECORD')">
        <InfoRecordMaintain v-if="infoRecordMaintainModal" :quotation="quotation" :materialTypeList="materialTypeList" :readonly="true"></InfoRecordMaintain>
      </Modal>
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
        v-model="logModal" :title="$t('LOG')">
        <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
          <TablePage :columnsList="logColumnList" :resultList="quotationLogList" :tableMaxHeight="800"></TablePage>
        </div>
      </Modal>
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
        v-model="supplierQuotationFilesModal" :title="$t('QUOTATION_FILE')">
        <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
          <FileDocument :attachments="supplierQuotationFiles"></FileDocument>
        </div>
      </Modal>
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
        v-model="cpcToSupervisorAttachmentsModal" :title="$t('APPROVE') + ' ' + $t('REFERENCE_FILE')">
        <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
          <FileDocument :attachments="cpcToSupervisorAttachments"></FileDocument>
        </div>
      </Modal>
      <!-- Table Log Comments -->
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
        v-model="flowCommentModal" :title="$t('COMMENTS')">
        <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
      </Modal>
  
    </section>
  </template>
  
  <script>
  import { mapGetters } from "vuex"
  import { mapActions } from "vuex"
  import { AlertInfo, AlertError } from "@/util/alert"
  import FileDocument from '@/components/FileDocument.vue'
  import { Translate, FloraEditorConfig } from "@/util/common"
  import moment from "moment"
  import FormRowTwo from '@/components/FormRowTwo'
  
  import { FileSchemaList } from "@/util/tableTitle"
  import InfoRecordMaintain from "@/views/quotation/InfoRecordMaintain"
  
  
  export default {
    name: "CpcMaintain",
    components: {
      FormRowTwo,
      FileDocument,
      InfoRecordMaintain
    },
    inject: ['reload'],
    created() {
      const vueInstance = this;
      // call status option
      vueInstance.$queryStatusList(vueInstance, 'supervisor/high-price-maintain').then(data => {
        if (data) {
          vueInstance.statusList = data;
          if (vueInstance.getSupervisorHighPriceStatus() == "") {
            vueInstance.setSupervisorHighPriceStatus(vueInstance.statusList[0].description);
            vueInstance.setSupervisorHighPriceStatusEnum(vueInstance.statusList[0]);
          }
          vueInstance.search(true);
        } else {
          AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
          });
          vueInstance.$router.push("/home");
        }
      });
    },
    data() {
      return {
        batchCollapse:'1',
        statusList: [],
        deltaPnModel: false, // deltaPn More Model control
        deltaPnValue: '', // deltaPn More Model data
        vnCodeModel: false, // Vendor Code More Model control
        vnCodeValue: '', // Vendor Code More Model data
        plantModel: false,
        plantValue: '',
        formNoModal: false,
        formNoValue: '',
        quotation: {},
        commentsModal: false,
        comments: "",
        historyCommentsModal: false,
        historyComments: "",
        infoRecordMaintainModal: false,
        logModal: false,
        quotationLogList: [],
        supplierQuotationFilesModal: false,
        supplierQuotationFiles: [],
        cpcToSupervisorAttachmentsModal: false,
        cpcToSupervisorAttachments: [],
        batchCommentsModal: false,
        batchComments: "",
        fileSchemaList: FileSchemaList(this),
        file: null, // 檔案上傳
        // 批次條件
        selectAllType: '',

        FloraEditorConfig: FloraEditorConfig(""),

        flowCommentModal: false,
        flowComment: '',
  
        quotationList: [],
        pageObj: {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        },
        actionType: "",
        quotationUuid: ""
      }
    },
    methods: {
      changePage(page) {
        this.pageObj.page = page - 1
        this.search(false)
      },
      ...mapGetters(["getSupervisorHighPriceStatus", "getSupervisorHighPriceDeltaPn", "getSupervisorHighPriceVendorCode",
        "getSupervisorHighPriceFromRfqDate", "getSupervisorHighPriceToRfqDate", "getModalSize", "getWindowsWidth", "getSupervisorHighPricePlant", "getSupervisorHighPriceFormNo"]),
      ...mapActions(["toggleLoading", "setSupervisorHighPriceStatus", "setSupervisorHighPriceStatusEnum", "setSupervisorHighPriceDeltaPn", "setSupervisorHighPriceVendorCode",
        "setSupervisorHighPriceFromRfqDate", "setSupervisorHighPriceToRfqDate", "setSupervisorHighPricePlant", "setSupervisorHighPriceFormNo"]),
      moreDeltaPn() {
        this.deltaPnModel = true
        this.setSupervisorHighPriceDeltaPn("")
      },
      confirmDeltaPnValue() {
        this.deltaPnValue.split('\n').forEach(a => {
          this.setSupervisorHighPriceDeltaPn(this.getSupervisorHighPriceDeltaPn().concat(a.trim() + ";"))
        })
        this.setSupervisorHighPriceDeltaPn(this.getSupervisorHighPriceDeltaPn().substr(0, this.getSupervisorHighPriceDeltaPn().length - 1))
      },
  
      moreVnCode() {
        this.vnCodeModel = true
        this.setSupervisorHighPriceVendorCode("")
      },
      confirmVnCodeValue() {
        this.vnCodeValue.split('\n').forEach(a => {
          this.setSupervisorHighPriceVendorCode(this.getSupervisorHighPriceVendorCode().concat(a.trim() + ";"))
        })
        this.setSupervisorHighPriceVendorCode(this.getSupervisorHighPriceVendorCode().substr(0, this.getSupervisorHighPriceVendorCode().length - 1))
      },
  
      morePlant() {
        this.plantModel = true
        this.setSupervisorHighPricePlant("")
      },
      confirmPlantValue() {
        this.plantValue.split('\n').forEach(a => {
          this.setSupervisorHighPricePlant(this.getSupervisorHighPricePlant().concat(a.trim() + ";"))
        })
        this.setSupervisorHighPricePlant(this.getSupervisorHighPricePlant().substr(0, this.getSupervisorHighPricePlant().length - 1))
      },

      moreFormNo() {
        this.formNoModal = true;
        this.setSupervisorHighPriceFormNo("");
      },
      confirmFormNoValue() {
        this.formNoValue.split("\n").forEach(a => {
          this.setSupervisorHighPriceFormNo(this.getSupervisorHighPriceFormNo().concat(a.trim() + ";"));
        });
        this.setSupervisorHighPriceFormNo(this.getSupervisorHighPriceFormNo().substr(0, this.getSupervisorHighPriceFormNo().length - 1));
      },

      cleanSelectAllType () {
        this.selectAllType = ""
      },
      showBatchCommentsModal(){
        this.batchCommentsModal = true
      },
        
      search(init) {
        const vueInstance = this
        if (!vueInstance.status) {
          AlertInfo(this, this.$t('COMMON_MESSAGE_NOT_AUTH'))
            .then(() => {
              vueInstance.$router.push("/home")
            })
          return
        }
        if (init) {
          vueInstance.pageObj = {
            "page": 0,
            "totalPage": 0,
            "totalCount": 0,
            "pageSize": 20
          }
        }
        vueInstance.cleanSelectAllType();
        vueInstance.quotationList = []
        let queryData = buildCriteria(vueInstance)
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supervisor/highPrice/search?page=" + vueInstance.pageObj.page + "&size=" + vueInstance.pageObj.pageSize, queryData)
          .then(response => {
            if (response.data.content.length === 0) {
              vueInstance.$Notice.success({
                title: Translate("COMMON_MESSAGE_INFO"),
                desc: Translate("COMMON_MESSAGE_INFO"),
                render: h => h("span", [Translate("COMMON_TEXT_NOTHING")])
              })
              return
            }
            vueInstance.pageObj = {
              "page": response.data.number + 1,
              "totalPage": response.data.totalPages,
              "totalCount": response.data.totalElements,
              "pageSize": response.data.size
            }
            vueInstance.quotationList = response.data.content
          })
          .catch(error => {
            console.error(error)
            AlertError(vueInstance, error)
              .then(() => {});
          })
          .finally(() => {
            vueInstance.toggleLoading(false)
          })
      },
      clear() {
        this.setSupervisorHighPriceStatus(this.statusList[0].description)
        this.setSupervisorHighPriceStatusEnum(this.statusList[0])
        this.setSupervisorHighPriceDeltaPn('')
        this.setSupervisorHighPriceFromRfqDate('')
        this.setSupervisorHighPriceToRfqDate('')
        this.setSupervisorHighPriceVendorCode('')
        this.setSupervisorHighPricePlant('')
        this.setSupervisorHighPriceFormNo("");
        this.deltaPnValue = ''
        this.vendorPnValue = ''
        this.vnCodeValue = ''
      },
      handleBatchSubmit(val){
        let vueInstance = this;
        if(val === "REJECT" && this.batchComments === ''){
          vueInstance.$Swal.fire({
              icon: "info",
              title: vueInstance.$t("COMMON_MESSAGE_INFO"),
              html: "Batch type is Reject, comments must not be blank",
            });
            return;
        }
        let queryData = buildCriteria(vueInstance)
          queryData.comment = this.batchComments;
          let url = val === "APPROVE" ? "/quotation/batch/supervisorHighPriceApproveSubmit" : "/quotation/batch/supervisorHighPriceRejectSubmit"
          vueInstance.toggleLoading(true);
          vueInstance.$quotationHttp
          .post(url, queryData)
          .then((response) => {
            vueInstance.toggleLoading(false);
            vueInstance.clear();
            vueInstance.reload();
          })
          .catch((error) => {
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          });
      },
      handleSubmit() {
        let vueInstance = this;
        let approveData = [], rejectData = [];
        vueInstance.quotationList.forEach(quotation => {
            let temp = {
              formNo: quotation.formNo,
              flowComment: quotation.comments
            }
            if (quotation.action === "REJECT") {
              rejectData.push(temp);
            }
            else if (quotation.action === "APPROVE") {
              approveData.push(temp);
            }
        });
        if (approveData.length > 0 || rejectData.length > 0) {
          vueInstance.toggleLoading(true);
          vueInstance.$quotationHttp
          .post("/quotation/supervisorHighPriceQuotationSubmit", JSON.stringify({
            quotationRequestListForApprove: approveData,
            quotationRequestListForReject: rejectData
          }))
          .then((response) => {
            vueInstance.toggleLoading(false);
            vueInstance.clear();
            vueInstance.reload();
          })
          .catch((error) => {
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          });
        }
        else {
          vueInstance.$Swal.fire({
            icon: "info",
            title: vueInstance.$t("COMMON_MESSAGE_INFO"),
            html: "No Select Submit Data",
          });
        }
      },
      stripHtmlTags(str) {
        return str.replace(/<[^>]*>/g, '');
      },
      clearAction(index) {
        this.quotationList[index].action = "";
      },
      showCommentsModal(index, uuid) {
        this.comments = this.quotationList[index].comments ?? "";
        this.actionType = this.quotationList[index].action ?? "";
        this.quotationUuid = uuid;
        this.commentsModal = true;
      },
      confirmComments() {
        this.quotationList.forEach(quotation => {
          if (quotation.uuid == this.quotationUuid) {
            quotation.comments = this.comments;
          } else if (this.actionType && this.actionType == quotation.action) {
            quotation.comments = this.comments;
          }
        });
      },
      showHistoryCommentsModal(index, uuid) {
        this.toggleLoading(true);
        this.$queryQuotationLog(this, uuid)
          .then(data => {
            this.quotationUuid = uuid;
            this.historyComments = "";
            data.forEach(log => {
              if (log.quotationRole) {
                this.historyComments = this.historyComments + this.$t("ROLE") + ": " + log.quotationRole + ", ";
              }
              if (log.quotationRole) {
                this.historyComments = this.historyComments + this.$t("STATUS") + ": " + log.flowStatus + ", ";
              }
              if (log.groupAccount) {
                this.historyComments = this.historyComments + this.$t("GROUP_ACCOUNT") + ": " + log.groupAccount.code + "/" + log.groupAccount.companyName + ", ";
              }
              if (log.created) {
                this.historyComments = this.historyComments + this.$t("CREATE_DATE") + ": " + log.created + ": <br>";
              }
              if (log.flowComment) {
                this.historyComments = this.historyComments + log.flowComment;
              }
              this.historyComments = this.historyComments + "<hr style=\"border:1px dashed #000; height:1px\">";
            });
            this.historyCommentsModal = true;
          })
          .catch(error => {
            console.error(error);
            AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
              .then(() => {});
          })
          .finally(() => {
            this.toggleLoading(false);
          });
      },
      showInfoRecordMaintainModal(index, uuid) {
        this.quotation = this.quotationList[index].quotationDetailInfoRecordDto;
        this.infoRecordMaintainModal = true;
      },
      showLogModal(index, uuid) {
        this.toggleLoading(true);
        this.$queryQuotationLog(this, uuid)
          .then(data => {
            this.quotationUuid = uuid;
            this.quotationLogList = data;
            this.logModal = true;
          })
          .catch(error => {
            console.error(error);
            AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
              .then(() => {});
          })
          .finally(() => {
            this.toggleLoading(false);
          });
      },
      showQuotationFilesModal(index) {
        this.supplierQuotationFiles = this.quotationList[index].supplierQuotationFiles.filter(attachment => !attachment.deleted);
        this.supplierQuotationFilesModal = true;
      },
      showReferenceFileModal(index) {
        this.cpcToSupervisorAttachments = this.quotationList[index].cpcToSupervisorAttachments.filter(attachment => !attachment.deleted);
        this.cpcToSupervisorAttachmentsModal = true;
      }
    },
    computed: {
      quotationColumnList() {
        return [{
          title: this.$t('ACTION'),
          width: 90,
          align: "center",
          slot: "action"
        }, {
          title: this.$t('COMMENTS'),
          width: 70,
          align: "center",
          slot: "comments"
        }, {
          renderHeader: (h, params) => {
            return h("div", [
              this.$t("HISTORY"),
              h("br"),
              this.$t("COMMENTS")
            ]);
          },
          width: 70,
          align: "center",
          slot: "historyComments"
        }, {
          renderHeader: (h, params) => {
            return h("div", [
              "Info",
              h("br"),
              "Record"
            ]);
          },
          width: 50,
          align: "center",
          slot: "infoRecord"
        }, {
          renderHeader: (h, params) => {
            return h("div", [
              "Single",
              h("br"),
              "/Cross"
            ]);
          },
          width: 50,
          align: "center",
          slot: "singleOrCross"
        }, {
          renderHeader: (h, params) => {
            return h("div", [
              this.$t("HIGH_PRICE"),
              h("br"),
              this.$t("REASON_CATEGORY")
            ]);
          },
          key: "highPriceCategory",
          width: 100,
          align: "center",
        }, {
          title: this.$t('DIFF'),
          key: "priceDiff",
          width: 50,
          align: "center",
          slot: "priceDifference"
        }, {
          title: "BG",
          key: "bg",
          width: 50,
          align: "center",
        }, {
          title: "BU",
          key: "bu",
          width: 50,
          align: "center",
        }, {
          title: this.$t('Plant'),
          key: "plant",
          width: 50,
          align: "center",
        }, {
          title: this.$t('DELTA_PN'),
          key: "partNo",
          width: 100,
          align: "center",
        }, {
          title: this.$t('PART_DESCRIPTION'),
          key: "partDescription",
          width: 100,
          align: "center",
        }, {
          title: this.$t('VENDOR_PART'),
          key: "vendorPartNo",
          width: 150,
          align: "center",
        }, {
          title: this.$t('VN_CODE'),
          key: "vendorCode",
          width: 80,
          align: "center",
        }, {
          title: this.$t('VN_NAME'),
          key: "vendorName",
          width: 100,
          align: "center",
        }, {
          title: this.$t('AGENT'),
          key: "agent",
          width: 80,
          align: "center",
        }, {
          title: this.$t('AGENT_NAME'),
          key: "agentName",
          width: 100,
          align: "center",
        }, {
          title: this.$t('UNIT_PRICE'),
          key: "unitPrice",
          width: 70,
          align: "center",
        }, {
          title: this.$t('CURRENCY'),
          key: "currency",
          width: 70,
          align: "center",
        }, {
          title: this.$t('LOG'),
          width: 50,
          align: "center",
          slot: "log"
        }, {
          title: this.$t('ITEM_CATEGORY'),
          key: "itemCategory",
          width: 100,
          align: "center",
        }, {
          title: this.$t('VALID_FROM'),
          key: "validFrom",
          width: 70,
          align: "center",
        }, {
          title: this.$t('VALID_TO'),
          key: "validTo",
          width: 70,
          align: "center",
        }, {
          title: this.$t('QUOTATION_FILE'),
          width: 55,
          align: "center",
          slot: "quotationFiles"
        }, {
          title: this.$t('REFERENCE_FILE'),
          width: 55,
          align: "center",
          slot: "referenceFile"
        }, {
          title: this.$t('APPLY_DATE'),
          key: "applyDate",
          width: 70,
          align: "center",
        }, {
          title: this.$t('FORM_NO'),
          key: "formNo",
          width: 150,
          align: "center",
        }]
      },
      logColumnList() {
        return [{
          title: this.$t('ROLE'),
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.quotationRole)
          }
        }, {
          title: this.$t('STATUS'),
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.flowStatus)
          }
        }, {
          title: 'Sequence',
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.sequence)
          }
        }, {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupAccount",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["groupAccount"].companyName)
          }
        }, {
          title: this.$t('ACTION'),
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.flowAction)
          }
        }, {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            if (params.row.flowComment) {
              return h("Icon", {
                props: {
                  type: "ios-paper",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.flowComment = params.row.flowComment
                    this.flowCommentModal = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
          }
        }, {
          title: this.$t('CREATE_DATE'),
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.created)
          }
        }, {
          title: this.$t('PERSON_ACCOUNT'),
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.personEmail)
          }
        }]
      },
      status: {
        get() {
          return this.getSupervisorHighPriceStatus()
        },
        set(value) {
          this.quotationList = []
          this.quotationGroupList = []
          this.setSupervisorHighPriceStatusEnum(this.statusList.find(status => status.description == value))
          return this.setSupervisorHighPriceStatus(value)
        }
      },
      deltaPn: {
        get() {
          return this.getSupervisorHighPriceDeltaPn()
        },
        set(value) {
          this.quotationList = []
          this.quotationGroupList = []
          return this.setSupervisorHighPriceDeltaPn(value.trim())
        }
      },
      vnCode: {
        get() {
          return this.getSupervisorHighPriceVendorCode()
        },
        set(value) {
          this.quotationList = []
          this.quotationGroupList = []
          return this.setSupervisorHighPriceVendorCode(value.trim())
        }
      },
      fromRfqDate: {
        get() {
          return this.getSupervisorHighPriceFromRfqDate()
        },
        set(value) {
          this.quotationList = []
          this.quotationGroupList = []
          return this.setSupervisorHighPriceFromRfqDate(value)
        }
      },
      toRfqDate: {
        get() {
          return this.getSupervisorHighPriceToRfqDate()
        },
        set(value) {
          this.quotationList = []
          this.quotationGroupList = []
          return this.setSupervisorHighPriceToRfqDate(value)
        }
      },
      plant: {
        get() {
          return this.getSupervisorHighPricePlant()
        },
        set(value) {
          this.quotationList = []
          this.quotationGroupList = []
          return this.setSupervisorHighPricePlant(value)
        }
      },
      formNo: {
        get() {
          return this.getSupervisorHighPriceFormNo();
        },
        set(value) {
          this.quotationList = [];
          this.quotationGroupList = [];
          return this.setSupervisorHighPriceFormNo(value);
        }
      },
      modalSize() {
        return this.getModalSize()
      },
      windowWidth() {
        return this.getWindowsWidth() - 50
      }
    },
    watch: {
      // 監聽 selectAllType 批次修改 Action
      selectAllType(value) {
        const vueInstance = this; 
        vueInstance.quotationList.forEach(quotation => {
          vueInstance.$set(quotation, 'action', value);
        });
      }
    },
  }

  function buildCriteria(vueInstance) {
    return {
      "deltaPartNos": vueInstance.deltaPn === "" ? [] : vueInstance.deltaPn.split(";"),
      "status": vueInstance.statusList.find(status => status.description == vueInstance.status)['statusViewEnum'],
      "vendorCodes": vueInstance.vnCode === "" ? [] : vueInstance.vnCode.split(";"),
      "fromRfqDate": vueInstance.fromRfqDate === "" ? null : moment(vueInstance.fromRfqDate).format('YYYY-MM-DD'),
      "toRfqDate": vueInstance.toRfqDate === "" ? null : moment(vueInstance.toRfqDate).format('YYYY-MM-DD'),
      "plantNos": vueInstance.plant === "" ? [] : vueInstance.plant.split(";"),
      "formNos": vueInstance.formNo === "" ? [] : vueInstance.formNo.split(";")
    }
  }
  </script>

  <style scoped>
  .select-small {
    width: 120px;
  }
  .button {
    width: auto;
  }
  .editBtn {
    width: auto;
    padding: 0 8px;
  }
  .editBtn i {
    color: white;
    font-size: 16px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  </style>
  <style>
  .highPriceTableBtn {
    padding: 5px 15px;
    border: 1px solid #2db7f5;
    background-color: white;
    border-radius: 3px;
    cursor: pointer;
    width: 60px;
  }
  .highPriceTableBtn:hover {
    background-color: #2db7f5;
    color: white;
  }
  
  .highPriceTable input[type="radio"] {
    vertical-align: text-bottom;
    margin-right: 5px;
  }
  .highPriceTable .radioContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
  }
  </style>